export default __webpack_public_path__ + "static/media/lo.af0ba476.png";